









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapServer } from '../../../../src/api/installService';
@Component({
  name: 'Capital',
  components: {},
})
export default class Capital extends Vue {
  @Prop() private drawPoint: any;
  private pageTemporaryStorage: any;
  private mounted(): void {
    this.getData();
  }
  private getData(): void {
    const that = this;
    mapServer.getCapital().then((res: any) => {
      if (res.status === 200) {
        const da = res.data.data;
        const val: any = [];
        const name: any = [];
        da.forEach((item: any) => {
          name.push(item.typeName);
          val.push({
            name: item.typeName,
            value: item.countNum,
          });
        });
        that.drawPie({
          name,
          value: val,
        });
      }
    });
  }
  // 流程占比 饼状图
  private drawPie(data: any) {
      const compairEchart: any = Vue.prototype.$echarts.init(this.$refs.publicPlace);
      const colors: any = ['#00ffff', '#00cfff', '#ffe000', '#ffa800', '#ff5b00',
          '#ff3000', '#96acff', '#75ff60', '#ff8bb6', '#9f31ff', '#ff6269',
      ];
      const option: any = {
          backgroundColor: 'transparent',
          grid: {
            containLabel: true,
            left: '15px',
          },
          tooltip: {
            trigger: 'item',
            formatter: ('{b} : {c} ({d}%)'),
          },
          legend: {
            x: 'right',
            orient: 'vertical',
            bottom: 'center',
            data: data.name,
            icon: 'circle',
            // itemWidth: 8,
            itemHeight: 5,
            type: 'scroll',
            itemGap: 6,
            padding: [0, 20, 10, 0],
            textStyle: {
              color: '#e2e9ff',
              fontSize: 15,
            },
          },
          calculable: true,
          color: colors,
          series: [{
              name: '',
              type: 'pie',
              startAngle: 0,
              radius: [20, 80],
              center: ['30%', '50%'],
              roseType: 'area',
              avoidLabelOverlap: false,
              label: {
                  normal: {
                      show: true,
                      formatter: '{c}',
                  },
                  emphasis: {
                      show: true,
                  },
              },
              labelLine: {
                  normal: {
                      show: true,
                      length: 5,
                      length2: 15,
                  },
                  emphasis: {
                      show: true,
                  },
              },
              data: data.value,
          },
          ],
      };
      compairEchart.setOption(option);
      compairEchart.on('click', (params: any) => {
          // // 调用父组件方法
          //  this.drawPoint(params);
      });
  }
}
